import { useCallback } from 'react';
import { formGuardStore } from '@/shared/lib/formGuardStore';

/**
 * Управление признаком несохранённых изменений текущей страницы: его выставляет форма,
 * а лейаут по нему предупреждает о потере правок при уходе с экрана.
 */
export const useFormGuardActions = () => {
  const setIsDirty = useCallback((isDirty: boolean) => {
    formGuardStore.setState({ isDirty });
  }, []);

  const resetFormGuard = useCallback(() => {
    formGuardStore.setState({ isDirty: false });
  }, []);

  return {
    setIsDirty,
    resetFormGuard,
  };
};
